module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-2021-1.33000556.jpg";